// --- UI Primitives ---
import {
  ToolbarGroup,
  ToolbarSeparator,
} from '@components/tiptap/tiptap-ui-primitive/toolbar'

// --- Tiptap Node ---
import '@components/tiptap/tiptap-node/blockquote-node/blockquote-node.scss'
import '@components/tiptap/tiptap-node/code-block-node/code-block-node.scss'
import '@components/tiptap/tiptap-node/heading-node/heading-node.scss'
import '@components/tiptap/tiptap-node/horizontal-rule-node/horizontal-rule-node.scss'
import '@components/tiptap/tiptap-node/image-node/image-node.scss'
import '@components/tiptap/tiptap-node/list-node/list-node.scss'
import '@components/tiptap/tiptap-node/paragraph-node/paragraph-node.scss'

// --- Tiptap UI ---
import { BlockquoteButton } from '@components/tiptap/tiptap-ui/blockquote-button'
import { CodeBlockButton } from '@components/tiptap/tiptap-ui/code-block-button'
import { ColorHighlightPopover } from '@components/tiptap/tiptap-ui/color-highlight-popover'
import { HeadingDropdownMenu } from '@components/tiptap/tiptap-ui/heading-dropdown-menu'
import { ImageUploadButton } from '@components/tiptap/tiptap-ui/image-upload-button'
import { LinkPopover } from '@components/tiptap/tiptap-ui/link-popover'
import { ListDropdownMenu } from '@components/tiptap/tiptap-ui/list-dropdown-menu'
import { MarkButton } from '@components/tiptap/tiptap-ui/mark-button'
import { TextAlignButton } from '@components/tiptap/tiptap-ui/text-align-button'
import { UndoRedoButton } from '@components/tiptap/tiptap-ui/undo-redo-button'

// --- Styles ---
import '@components/tiptap/tiptap-templates/simple/simple-editor.scss'

import { Spacer } from '@components/tiptap/tiptap-ui-primitive/spacer'

// Import required styles
import '@components/tiptap/tiptap-node/table-node/styles/prosemirror-table.scss'
import '@components/tiptap/tiptap-node/table-node/styles/table-node.scss'
import { TableTriggerButton } from '@components/tiptap/tiptap-node/table-node/ui/table-trigger-button'
import { VariablesDropdown } from '@components/tiptap/tiptap-ui/variables-dropdown'

type MainToolbarContentProps = {
  mode?: 'simple' | 'full'
}

export const MainToolbarContent = ({
  mode = 'full',
}: MainToolbarContentProps) => {
  return (
    <>
      <Spacer />

      <ToolbarGroup>
        <UndoRedoButton action="undo" />
        <UndoRedoButton action="redo" />
      </ToolbarGroup>

      <ToolbarSeparator />

      <ToolbarGroup>
        {/* Mode simple: seulement heading niveau 2 et 3 */}
        {mode === 'full' && <HeadingDropdownMenu levels={[1, 2, 3, 4]} />}

        {/* Mode simple: seulement bulletList et orderedList */}
        {mode === 'full' && (
          <ListDropdownMenu types={['bulletList', 'orderedList']} />
        )}

        {/* Blockquote et CodeBlock seulement en mode full */}
        {mode === 'full' && (
          <>
            <BlockquoteButton />
            <CodeBlockButton />
          </>
        )}

        {/* Table seulement en mode full */}
        {mode === 'full' && <TableTriggerButton />}
      </ToolbarGroup>

      <ToolbarSeparator />

      <ToolbarGroup>
        <MarkButton type="bold" />
        <MarkButton type="italic" />
        <MarkButton type="strike" />
        {mode === 'full' && <MarkButton type="code" />}
        <MarkButton type="underline" />

        {mode === 'full' && <ColorHighlightPopover />}
        <LinkPopover />
      </ToolbarGroup>

      {mode === 'full' && (
        <>
          <ToolbarSeparator />
          <ToolbarGroup>
            <MarkButton type="superscript" />
            <MarkButton type="subscript" />
          </ToolbarGroup>
        </>
      )}

      {mode === 'full' && (
        <>
          <ToolbarSeparator />
          <ToolbarGroup>
            <TextAlignButton align="left" />
            <TextAlignButton align="center" />
            <TextAlignButton align="right" />
            <TextAlignButton align="justify" />
          </ToolbarGroup>
        </>
      )}

      {mode === 'full' && (
        <>
          <ToolbarSeparator />
          <ToolbarGroup>
            <ImageUploadButton text="Add" />
          </ToolbarGroup>
        </>
      )}
      <ToolbarSeparator />
      <VariablesDropdown />

      <Spacer />
    </>
  )
}
